
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/investments",
      function () {
        return require("private-next-pages/investments/investments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/investments"])
      });
    }
  